
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/hooks/useLanguage';
import { Search, X, Loader2 } from 'lucide-react';

interface CVESearchBarProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
  searchLoading: boolean;
  filteredResultsCount: number;
}

export function CVESearchBar({ 
  searchQuery, 
  onSearchChange, 
  onClearSearch, 
  searchLoading, 
  filteredResultsCount 
}: CVESearchBarProps) {
  const { t } = useLanguage();

  return (
    <div className="relative">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          type="text"
          placeholder={t('cve.searchPlaceholder')}
          value={searchQuery}
          onChange={onSearchChange}
          className="pl-10 pr-10"
        />
        {searchQuery && (
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-1 top-1/2 -translate-y-1/2 h-8 w-8 p-0 opacity-70 hover:opacity-100"
            onClick={onClearSearch}
          >
            <X className="h-4 w-4" />
            <span className="sr-only">{t('cve.clearSearch')}</span>
          </Button>
        )}
      </div>
      {searchQuery && (
        <div className="mt-2">
          {searchLoading ? (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>{t('cve.searching_progress')}</span>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">
              {filteredResultsCount === 0 
                ? t('cve.noSearchResults')
                : t('cve.searchResults', { count: filteredResultsCount })}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
